import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

const store = (set) => {
  return {
    player: null,
    setPlayer: (player) => {
      set({player});
    },
  };
};

const useSoopiEmbedStore = create(devtools(store));
export default useSoopiEmbedStore;
